import React, { useRef, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import CalendarHeader from "../../components/Applications/calendar/CalendarHeader";
import EventModal from "../../components/modals/calendar/EventModal";
import Sidebar from "../../components/Applications/calendar/Sidebar";
// import Sidebar from "./Sidebar";
// import EventModal from "./EventModal";

const CalendarPage = () => {
  const calendarRef = useRef(null);

  const [events, setEvents] = useState([
    {
      title: "Meeting with Team Dev",
      date: "2026-04-12",
      className: "event-pink",
    },
    {
      title: "Design System",
      date: "2026-04-15",
      className: "event-danger",
    },
    {
      title: "UI/UX Team",
      date: "2026-04-18",
      className: "event-info",
    },
  ]);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [show, setShow] = useState(false);
  const [currentTitle, setCurrentTitle] = useState("April 2026");
  const [currentView, setCurrentView] = useState("dayGridMonth");

  // 👉 Navigation
  const handlePrev = () => {
    calendarRef.current.getApi().prev();
  };

  const handleNext = () => {
    calendarRef.current.getApi().next();
  };

  const handleToday = () => {
    calendarRef.current.getApi().today();
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
    calendarRef.current.getApi().changeView(view);
  };

  const handleDatesSet = (dateInfo) => {
    setCurrentTitle(dateInfo.view.title);
  };

  // 👉 Event Click
  const handleEventClick = (info) => {
    setSelectedEvent(info.event);
    setShow(true);
  };

  return (
    <div style={{ padding: "15px", background: "#f8f9fa" }}>
      <CalendarHeader />

      <Row>
        {/* Sidebar */}
        <Col xxl={3} xl={4}>
          <Sidebar />
        </Col>

        {/* Calendar */}
        <Col xxl={9} xl={8}>
          <Card className="border-0">
            <Card.Body>
              {/* Header Controls */}
              <div className="calendar-header align-items-center justify-content-between">
                <div className="calendar-nav-buttons d-flex gap-2">
                  <button
                    onClick={handleToday}
                    className="btn btn-light btn-sm"
                  >
                    Today
                  </button>
                  <button onClick={handlePrev} className="btn btn-light btn-sm">
                    ‹
                  </button>
                  <button onClick={handleNext} className="btn btn-light btn-sm">
                    ›
                  </button>
                </div>

                <div className="calendar-title text-center">
                  <strong>{currentTitle}</strong>
                </div>

                <div className="calendar-view-buttons d-flex gap-2">
                  <button
                    type="button"
                    onClick={() => handleViewChange("dayGridMonth")}
                    className={`btn btn-sm ${currentView === "dayGridMonth" ? "btn-orange" : "btn-white"}`}
                  >
                    Month
                  </button>
                  <button
                    type="button"
                    onClick={() => handleViewChange("timeGridWeek")}
                    className={`btn btn-sm ${currentView === "timeGridWeek" ? "btn-orange" : "btn-white"}`}
                  >
                    Week
                  </button>
                  <button
                    type="button"
                    onClick={() => handleViewChange("timeGridDay")}
                    className={`btn btn-sm ${currentView === "timeGridDay" ? "btn-orange" : "btn-white"}`}
                  >
                    Day
                  </button>
                </div>
              </div>

              {/* Calendar */}
              <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                headerToolbar={false}
                events={events}
                eventClick={handleEventClick}
                datesSet={handleDatesSet}
                height="auto"
              />
            </Card.Body>
          </Card>
        </Col>

        {/* Modal */}
        <EventModal
          show={show}
          handleClose={() => setShow(false)}
          event={selectedEvent}
        />
      </Row>
      <style>
        {`
        .calendar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 20px;
        }

        .calendar-nav-buttons,
        .calendar-view-buttons {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .calendar-title {
          flex: 1;
          text-align: center;
          font-size: 1rem;
          color: #111827;
        }

        .calendar-title strong {
          font-size: 1.05rem;
          letter-spacing: 0.02em;
        }

        .calendar-header .btn-light {
          min-width: 38px;
          padding: 0.5rem 0.7rem;
          border: 1px solid #d1d5db;
          color: #111827;
          background: #ffffff;
        }

        .calendar-header .btn-white {
          min-width: 64px;
          padding: 0.45rem 0.95rem;
          border-radius: 999px;
          border: 1px solid #d1d5db;
          color: #111827;
          background: #ffffff;
          box-shadow: none;
        }

        .calendar-header .btn-orange {
          min-width: 64px;
          padding: 0.45rem 0.95rem;
          border-radius: 999px;
          border: 1px solid transparent;
          background: #ff6a00;
          color: #ffffff;
        }

        .calendar-header .btn-orange:hover,
        .calendar-header .btn-light:hover {
          opacity: 0.92;
        }

        .calendar-header .btn-white:hover {
          background: #f8fafc;
        }

        .fc .fc-daygrid-day {
          height: 100px;
        }

.event-pink {
  background: #f9c2d1 !important;
  border: none !important;
}

.event-danger {
  background: #f8b4b4 !important;
}

.event-info {
  background: #cce5ff !important;
}

/* Sidebar */
.event-item {
  padding-left: 10px;
  margin-bottom: 10px;
}

.upgrade-box {
  background: #111;
  color: white;
  padding: 20px;
  border-radius: 10px;
}

/* Modal */
.modal-header-custom {
  background: linear-gradient(90deg, #111, #333);
  color: white;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
}
  
// color
/* ===== DAY NAMES (Sun Mon Tue...) ===== */
.fc .fc-col-header-cell-cushion {
  color: #1e1d1d !important;
  font-weight: 600;
  text-decoration: none !important;
}

/* ===== DAY NUMBERS ===== */
.fc .fc-daygrid-day-number {
  color: #1f1f1f !important;
  font-weight: 500;
  text-decoration: none !important;
}

/* ===== REMOVE BLUE LINK STYLE ===== */
.fc a {
  color: #1f1d1d !important;
  text-decoration: none !important;
}

/* ===== OTHER MONTH DAYS (light grey like image) ===== */
.fc .fc-day-other .fc-daygrid-day-number {
  color: #9ca3af !important;
}

/* ===== TODAY (optional soft highlight like your image) ===== */
.fc .fc-day-today {
  background-color: #f3ecd2 !important; /* light yellow */
}

/* ===== HEADER TITLE (April 2026) ===== */
.fc-toolbar-title {
  color: #131313 !important;
  font-weight: 600;
}

/* ===== BUTTON TEXT ===== */
.fc-button {
  color: #181717 !important;
}

`}
      </style>
    </div>
  );
};

export default CalendarPage;
